export const TextContentProcessor = () => ({
  "x-init"() {
    // Allow adaptable image widths
    this.$el.querySelectorAll('img[width]').forEach((img) => {
      img.style.width = `${img.getAttribute('width')}px`
    });

    // Wrap tables
    this.$el.querySelectorAll('table').forEach((table) => {
      if (table.closest('.table-wrapper')) return;

      const tableWrapper = document.createElement('div');
      tableWrapper.classList.add('table-wrapper');
      tableWrapper.appendChild(table.cloneNode(true));
      table.outerHTML = tableWrapper.outerHTML;
    });
  }
});
